<template>
  <div>
    <!-- Dialog Trigger -->
    <button
      @click="openDialog"
      class="relative inline-flex items-center justify-center whitespace-nowrap rounded-md text-xs font-medium transition-colors duration-200 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 text-pink-700 text-primary underline-offset-4 hover:underline text-wrap text-left gap-1"
    >
      {{ triggerLabel }}
      <img :src="openIcon" class="size-3 text-pink-700 stroke-pink-700" />
    </button>

    <!-- Modal Dialog -->
    <dialog
      ref="videoDialog"
      class="text-neutral-700 fixed inset-0 mx-auto p-0 bg-white rounded-lg shadow-lg md:w-11/12 max-w-2xl backdrop:backdrop-blur-sm cursor-auto backdrop:pointer-events-none"
      @close="handleOnClose"
    >
      <div class="p-4">
        <div class="flex justify-between items-center mb-4">
          <h2 class="text-xl font-semibold">{{ dialogTitle }}</h2>
          <button
            @click="closeDialog"
            class="aspect-square p-2 block rounded-full hover:bg-neutral-700 hover:bg-opacity-10 stroke-current"
          >
            <img class="size-4" :src="closeIcon" />
          </button>
        </div>
        <video controls :src="videoSource" class="w-full rounded-lg"></video>
      </div>
    </dialog>
  </div>
</template>

<script setup>
import closeIcon from "@assets/images/icons/close-icon.svg";
import openIcon from "@assets/images/icons/open-icon.svg";
</script>

<script>
export default {
  name: "VideoModal",
  props: {
    dialogTitle: {
      type: String,
      required: true,
    },
    videoSource: {
      type: String,
      required: true,
    },
    triggerLabel: {
      type: String,
      required: true,
    },
  },
  methods: {
    openDialog() {
      this.$refs.videoDialog.showModal();
    },
    closeDialog() {
      this.$refs.videoDialog.close();
    },
    handleOnClose() {
      this.$refs.videoDialog.querySelector("video").pause();
    },
  },
};
</script>

<style>
html:has(dialog[open]) {
  overflow: hidden;
}
</style>
